/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  getEstateInterventionListLink,
  getEstateLeaseListLink,
  getEstateLink,
  getEstateMandateListLink,
  getEstateProspectingListLink
} from '../../lib/links/estateLinks'
import { Button, ButtonVariant, Group } from '@mantine/core'
import { useLocation } from 'react-router'
import { matchPath, NavLink } from 'react-router-dom'
import RequirePerm from '../../../auth/components/RequirePerm'

export type EstateTabsProps = {
  estateId: number
}

function EstateTabs (props: EstateTabsProps) {
  const intl = useIntl()
  const { estateId } = props
  const disabled = !(estateId > 0)
  const location = useLocation()
  const activeVariant: ButtonVariant = 'outline'
  const inactiveVariant: ButtonVariant = 'white'
  return (
    <Group gap="xs">
      <Button
        disabled={disabled}
        component={NavLink}
        to={getEstateLink(estateId)}
        variant={matchPath(getEstateLink(':id'), location.pathname) ? activeVariant : inactiveVariant}
      >
        {intl.formatMessage({
          id: 'record',
          defaultMessage: 'Fiche'
        })}
      </Button>
      <RequirePerm
        permissions={['read:lease']}
        render={() => (
          <Button
            disabled={disabled}
            component={NavLink}
            to={getEstateLeaseListLink(estateId)}
            variant={matchPath(getEstateLeaseListLink(':id'), location.pathname) ? activeVariant : inactiveVariant}
          >
            {intl.formatMessage({
              id: 'leases',
              defaultMessage: 'Dossiers de location'
            })}
          </Button>
        )}
      />
      <RequirePerm
        permissions={['read:intervention']}
        render={() => (
          <Button
            disabled={disabled}
            component={NavLink}
            to={getEstateInterventionListLink(estateId)}
            variant={matchPath(getEstateInterventionListLink(':id'), location.pathname) ? activeVariant : inactiveVariant}
          >
            {intl.formatMessage({
              id: 'interventions',
              defaultMessage: 'Interventions'
            })}
          </Button>
        )}
      />
      <RequirePerm
        permissions={['read:mandate']}
        render={() => (
          <Button
            disabled={disabled}
            component={NavLink}
            to={getEstateMandateListLink(estateId)}
            variant={matchPath(getEstateMandateListLink(':id'), location.pathname) ? activeVariant : inactiveVariant}
          >
            {intl.formatMessage({
              id: 'mandates',
              defaultMessage: 'Mandats'
            })}
          </Button>
        )}
      />
      <RequirePerm
        permissions={['read:prospecting']}
        render={() => (
          <Button
            disabled={disabled}
            component={NavLink}
            to={getEstateProspectingListLink(estateId)}
            variant={matchPath(getEstateProspectingListLink(':id'), location.pathname) ? activeVariant : inactiveVariant}
          >
            {intl.formatMessage({
              id: 'prospecting_list',
              defaultMessage: 'Prospections'
            })}
          </Button>
        )}
      />
    </Group>
  )
}

export default EstateTabs
